<color-chrome
  class="cl-ui-chrome-picker"
  [color]="color"
  (onChangeComplete)="handleColorChange($event)"
  [disableAlpha]="true"
></color-chrome>
